import gql from 'graphql-tag';

export const getCostOffsetCodeQuery = gql(/* GraphQL */ `
  query getCostOffsetCode(
    $getCostOffsetCodeRequest: GetCostOffsetCodeRequest!
  ) {
    costOffsetCode(getCostOffsetCodeRequest: $getCostOffsetCodeRequest) {
      id
      code
      description
      groupId
      groupType
    }
  }
`);
